export type TaskType =
  | 'GET_LOGS'
  | 'TEST_PUBLICATIONS'
  | 'TEST_PJ'
  | 'TEST_MAILS'
  | 'CLOSE_OFFER'
  | 'MANAGE_SIEGE_USER'
  | 'UNMANAGE_SIEGE_USER'
  | 'GENERATE_PJ_RESIDENT'
  | 'GENERATE_PJ_RESIDENCE'
  | 'GENERATE_ARCHIVE_RESIDENT';
